import React from "react"
import { makeStyles } from "@material-ui/styles"
import Typography from "@material-ui/core/Typography"
import { FormattedMessage } from "react-intl"

const useStyles = makeStyles(theme => ({
  font: {
    color: "#ffffff",
    fontSize: "12px",
    opacity: 0.7,
  },
}))

const TextCopyright = () => {
  const classes = useStyles()

  return (
    <Typography className={classes.font} id="textCopyright">
      <FormattedMessage id="TextCopyright.Copyright" />
    </Typography>
  )
}

export default TextCopyright
